import React from 'react';
import Markdown from 'react-markdown';

import './markdownContent.scss';

// Single source of truth for rendering markdown inside a liv chat surface.
// Styling rules for markdown elements (strong, h1, ul, …) are scoped under
// `.liv-markdown` in the colocated markdownContent.scss, imported above so
// the component carries its own styles wherever it's mounted — no reliance
// on brand-specific style wiring.
const MarkdownContent = ({ children }) => (
  <div className="liv-markdown">
    <Markdown>{children}</Markdown>
  </div>
);

export { MarkdownContent };
